import styled from '../../../lib/styled';
import React from 'react';
import { FC } from 'react';
import { colors } from '../../Shared/Style/colors';
import Icon from '../event-create.svg';

const ThemedBooking = styled(Icon)(() => {
    return {
        height: '24px',
        width: '24px',
        '& g': {
            stroke: colors.icons,
        },
        '& path': {
            stroke: colors.icons,
        },
        '& polyline': {
            stroke: colors.icons,
        },
    };
});
const Booking: FC = ({ ...rest }) => {
    return <ThemedBooking {...rest} />;
};

export default Booking;
